import React from 'react';
import Header2 from './components/Header2';
import Experience2 from './components/Experience2';
import Projects2 from './components/Projects2';
import Extracurricular from './components/Extracurricular';
import Home from './components/Home';
import './App.css';

function App() {
  return (
    <div className="App">
      <main>
        <Header2 />
        <Experience2 />
        <Projects2 />
      </main>
    </div>
  );
}

export default App;
